var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDispatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9ca3af",
    viewBox: "0 0 23 23",
    strokeWidth: 2,
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 491.1 491.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M401.5 863.31c-12 0-23.4 4.7-32 13.2-8.6 8.6-13.4 19.8-13.4 31.8s4.7 23.2         13.4 31.8c8.7 8.5 20 13.2 32 13.2 24.6 0 44.6-20.2 44.6-45s-20-45-44.6-45zm0         70c-13.8 0-25.4-11.4-25.4-25s11.6-25 25.4-25c13.6 0 24.6 11.2 24.6 25s-11 25-24.6         25zm11.6-219.9c-1.8-1.7-4.2-2.6-6.7-2.6h-51.3c-5.5 0-10 4.5-10 10v82c0 5.5 4.5 10 10         10h81.4c5.5 0 10-4.5 10-10v-54.9c0-2.8-1.2-5.5-3.3-7.4l-30.1-27.1zm13.4 79.4h-61.4v-62.1h37.4l24         21.6v40.5zm-269.2 70.5c-12 0-23.4 4.7-32 13.2-8.6 8.6-13.4 19.8-13.4 31.8s4.7 23.2 13.4 31.8c8.7         8.5 20 13.2 32 13.2 24.6 0 44.6-20.2 44.6-45s-20-45-44.6-45zm0 70c-13.8 0-25.4-11.4-25.4-25s11.6-25         25.4-25c13.6 0 24.6 11.2 24.6 25s-11 25-24.6 25zm-66.7-57.7H70.5v-26.6c0-5.5-4.5-10-10-10s-10 4.5-10         10v36.6c0 5.5 4.5 10 10 10h30.1c5.5 0 10-4.5 10-10s-4.5-10-10-10zm50.7-54.5c0-5.5-4.5-10-10-10H10c-5.5         0-10 4.5-10 10s4.5 10 10 10h121.3c5.5 0 10-4.4 10-10zm-111-36.1l121.3.7c5.5 0         10-4.4 10.1-9.9.1-5.6-4.4-10.1-9.9-10.1l-121.3-.7h-.1c-5.5 0-10 4.4-10 9.9-.1 5.6 4.4         10.1 9.9 10.1zm20.4-45.4H172c5.5 0 10-4.5 10-10s-4.5-10-10-10H50.7c-5.5 0-10 4.5-10 10s4.5 10 10 10z",
    transform: "translate(0 -540.36)",
    stroke: "#9ca3af",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.4 726.11l-71.6-59.3c-1.8-1.5-4-2.3-6.4-2.3h-84.2v-36c0-5.5-4.5-10-10-10H60.5c-5.5         0-10 4.5-10 10v73.2c0 5.5 4.5 10 10 10s10-4.5 10-10v-63.2h234.8v237.1h-82c-5.5 0-10 4.5-10 10s4.5 10         10 10h122.1c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20.1v-191.1h80.6l65.2 54-.7 136.9H460c-5.5 0-10 4.5-10         10s4.5 10 10 10h20.3c5.5 0 10-4.4 10-9.9l.8-151.6c-.1-3-1.4-5.9-3.7-7.8z",
    transform: "translate(0 -540.36)",
    stroke: "#9ca3af",
    strokeWidth: 13
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatch);
export default __webpack_public_path__ + "static/media/dispatch.14c3f6999de521c97a72de8e2f4e7142.svg";
export { ForwardRef as ReactComponent };